import { IconProps } from "@/src/sb/business-layer/types"

const Sectors = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.3142 4.6125C22.0822 4.47853 21.7963 4.47853 21.5642 4.6125L15.1667 7.785V5.25C15.166 4.99006 15.0306 4.74905 14.8091 4.61307C14.5875 4.47709 14.3114 4.46552 14.0792 4.5825L7.66675 7.785V2.25C7.66675 1.83579 7.33096 1.5 6.91675 1.5H2.41675C2.00253 1.5 1.66675 1.83579 1.66675 2.25V21H22.6667V5.25C22.6673 4.99087 22.534 4.74984 22.3142 4.6125ZM16.6667 19.5H13.6667V14.25H16.6667V19.5ZM21.1667 19.5H18.1667V13.5C18.1667 13.0858 17.831 12.75 17.4167 12.75H12.9167C12.5025 12.75 12.1667 13.0858 12.1667 13.5V19.5H3.16675V3H6.16675V10.215L13.6667 6.465V10.215L21.1667 6.465V19.5Z"
      fill="currentColor"
    />
  </svg>
)

export default Sectors
